'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var AbstractFormView = require('components/common/views/abstract_form_view');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Strings = require('utils/strings');
var Notification = require('utils/notification');

var ConfigureValueDialogView = AbstractFormView.extend({
    template: require('components/common/templates/configure_value_dialog'),

    events: function () {
        return _.extend({}, AbstractFormView.prototype.events, {
            'click button#js-save': 'validateForm',

            'change #type_select-input': function (e) {
                this.formData.type_select = $('select.js-type-select').val();
                this.render();
            },

            'change #data_type_select-input': 'reInitializeModel',
            'click #js-fixed-unit': 'reInitializeModel',
            'click #js-signed': 'reInitializeModel',
            'click #js-little_endian': 'reInitializeModel',
            'click #js-decimal_combination': 'reInitializeModel',

            'click #js-test-config': 'testConfiguration',

            'click .js-delete-resolution': 'deleteValueResolution',
            'click #js-add-resolution': 'addValueResolution',
        });
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.options = options;

        this.model = options.model;
        if (this.model) {
            this.model = this.model.clone();
        }
        this.clone = options.clone;
        if (this.clone) {
            this.clone = JSON.parse(JSON.stringify(this.clone));
        }

        this.supportedDataTypes = [
            {
                name: i18n.TR('Zahl'),
                value: 'number',
                format: '',
            },
            {
                name: i18n.TR('Festkommazahl x.x'),
                value: 'x.x',
                format: '/10f1',
            },
            {
                name: i18n.TR('Festkommazahl x.xx'),
                value: 'x.xx',
                format: '/100f2',
            },
            {
                name: i18n.TR('Gleitkommazahl (32 Bit)'),
                value: 'float',
                format: '/1000',
                length: 2,
            },
            {
                name: i18n.TR('Uhrzeit'),
                value: 'time',
                format: 'p0-4t##:##',
            },
            {
                name: i18n.TR('Datum'),
                value: 'date',
                format: 't##.##.',
            },
            {
                name: i18n.TR('Skalierung'),
                value: 'value_mapping',
                format: /m(\[.*\])f2/i,
            },
            {
                name: i18n.TR('Ersatztexte'),
                value: 'value_resolution',
                format: /r(\{.*\})/i,
            },
        ];

        this.isSpecialFormat = false;
        var initialFormData = {};
        if (options.model || this.clone) {
            var self = this;

            initialFormData = options.model ? options.model.toJSON() : this.clone;
            initialFormData['type_select'] = initialFormData.type;
            initialFormData['data_type'] =
                Misc.selectWhereFirst(
                    this.supportedDataTypes,
                    function (x) {
                        var f = initialFormData['format'] || '';

                        if (x.format === f) {
                            return true;
                        }

                        if (x.value == 'value_mapping') {
                            var match = f.match(x.format);
                            if (match != null && match.length == 2) {
                                var baseMapping = JSON.parse(match[1]);
                                initialFormData['value_mapping'] = self.fromBaseMapping(
                                    baseMapping,
                                    initialFormData['min'],
                                    initialFormData['max']
                                );
                                return true;
                            }
                        }
                        if (x.value == 'value_resolution') {
                            var match = f.match(x.format);
                            if (match != null) {
                                initialFormData['value_resolution'] = [];
                                _.each(JSON.parse(match[1]), function (v, k) {
                                    initialFormData['value_resolution'].push({
                                        key: k,
                                        value: v,
                                    });
                                });
                                initialFormData['value_resolution'] = _.sortBy(
                                    initialFormData['value_resolution'],
                                    function (vr) {
                                        return parseInt(vr.key);
                                    }
                                );
                                return true;
                            }
                        }

                        return false;
                    },
                    'value'
                ) || 'special_format';
            this.isSpecialFormat = initialFormData['data_type'] === 'special_format';
            initialFormData['coil_mapping'] = [
                Strings.formatCoilValue(0, initialFormData.type, initialFormData.format),
                Strings.formatCoilValue(1, initialFormData.type, initialFormData.format),
            ];

            if (this.clone) {
                // remove number and name
                initialFormData['name'] = undefined;
                initialFormData['nr'] = undefined;
            }
        } else {
            initialFormData.type_select = 'MBR';
        }

        AbstractFormView.prototype.initialize.apply(this, [
            {
                formData: initialFormData,
                inputFields: {
                    name: {},
                    type_select: {},
                    nr: {},
                    length: { min: 1, max: 4 },
                    min: { validIfNotVisible: true },
                    max: { validIfNotVisible: true },
                    data_type_select: { validIfNotVisible: true },
                    unit: { validIfNotVisible: true, min: 0 },
                    update_class_select: {},
                    vmapping_min: { validIfNotVisible: true },
                    vmapping_max: { validIfNotVisible: true },
                    cmapping_0: { validIfNotVisible: true, min: 0 },
                    cmapping_1: { validIfNotVisible: true, min: 0 },
                },
            },
        ]);
    },

    calculateLinearFunction: function (x1, y1, x2, y2, v) {
        var m = (y2 - y1) / (x2 - x1);
        var n = y1 - m * x1;

        return m * v + n;
    },

    fromBaseMapping: function (base, min, max) {
        return [
            this.calculateLinearFunction(0, base[0], 1000, base[1], min),
            this.calculateLinearFunction(0, base[0], 1000, base[1], max),
        ];
    },

    toBaseMapping: function (mapping, min, max) {
        return [
            this.calculateLinearFunction(min, mapping[0], max, mapping[1], 0),
            this.calculateLinearFunction(min, mapping[0], max, mapping[1], 1000),
        ];
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);

        var self = this;
        var getDisplayUnit = function (data) {
            var displayUnit = data.display_unit;
            if (!displayUnit && self.model) {
                return self.model.get('unit');
            }
            if (!displayUnit && self.clone) {
                return self.clone['unit'];
            }
            return displayUnit;
        };

        data.dataTypes =
            this.model === undefined
                ? this.supportedDataTypes
                : _.filter(this.supportedDataTypes, function (dt) {
                      return dt.length == undefined || dt.length == self.model.get('length');
                  });

        data.isExpert = AppState.user.get('is_expert');
        data.isPredefined = this.model && this.model.get('spec') > 0;
        data.isNew = this.model === undefined;
        data.isAlwaysReadonly = data.formData.type_select == 'MBI' || data.formData.type_select == 'MBD';

        data.canChangeUnit = data.isNew || !data.isPredefined || data.formData.is_unit_fixed;

        data.formData.unitFixed = data.formData.is_unit_fixed;
        data.formData.unit = getDisplayUnit(data.formData);

        data.special_format = data.formData.data_type === 'special_format';

        var isOriginalFloat = this.model ? this.model.get('format') == '/1000' : false; // HINT: float detection is done indirectly via 'format'

        var configWarningRequired =
            (this.model && !isOriginalFloat && data.formData.data_type == 'float') || // existing value switching to float
            (this.model && isOriginalFloat && data.formData.data_type != 'float') || // existing value switching from float to any other data type
            (this.model && this.model.get('is_little_endian') != data.formData.is_little_endian) || // change in endianess
            (this.model && this.model.get('is_signed') != data.formData.is_signed) || // change signed <-> unsigned
            (this.model && this.model.get('is_decimal_combination') != data.formData.is_decimal_combination); // change in combination mode
        data.configWarning = configWarningRequired
            ? i18n.TR(
                  'Änderung am Rohdatenformat. Dies kann in Kombination mit bereits erfassten Daten zu Inkonsistenzen führen.'
              )
            : '';

        data.testDisabled = this.testResultIsFetched || data.formData.length > 4;
        data.testResultIsFetched = this.testResultIsFetched;
        data.testResult = this.testResult;

        data.formData.type_class_select = Misc.getValueTypeClass(data.formData.type_select);
        data.canConfigureNonDefaultModbusDataPoints =
            this.options.deviceCategory === Consts.CategoryData.Modbus.category;

        if (data.formData.data_type === 'value_resolution') {
            var rows = this.formData.value_resolution || [];
            if (rows.length == 0) {
                rows = [{ key: '', value: '' }];
            }

            data.valueConfiguration = {
                rows: rows,

                columnConfiguration: [
                    {
                        width: 3,
                        placeholder: rows.length,
                        heading: i18n.TR('Wert'),
                        namePrefix: 'value-resolution-k',
                        inputType: 'simple',
                        contentType: 'number',
                    },
                    {
                        width: 8,
                        placeholder: i18n.TR('Ersatztext'),
                        heading: i18n.TR('Ersatztext'),
                        namePrefix: 'value-resolution-v',
                        inputType: 'simple',
                        contentType: 'text',
                    },
                ],

                deleteButtonIDPrefix: 'value-resolution',
                deleteButtonClass: 'js-delete-resolution',

                canAddEntry: rows.length < 10,
                addButtonID: 'js-add-resolution',
            };
        }
        if (
            this.options.smartTempInfo &&
            this.options.smartTempInfo.getProtectedValues(true).includes(this.model.getAddress())
        ) {
            data.smartTempActive = true;
            data.configWarning = i18n.TR(
                'Wert wird von Smart Temp verwendet und kann daher nicht editiert werden, solange Smart Temp aktiv ist.'
            );
        }
        return data;
    },

    deleteValueResolution: function (e) {
        var index = parseInt(e.currentTarget.id.substring(17));
        this.formData.value_resolution.splice(index, 1);
        this.render();
    },

    addValueResolution: function (e) {
        var form = Backbone.Syphon.serialize(this);

        this.formData.value_resolution = this.getValueResolution(form);
        this.formData.value_resolution.push({
            key: '',
            value: '',
        });
        this.render();
    },

    getValueResolution: function (form) {
        if (form.data_type_select != 'value_resolution') {
            return [];
        }

        var i = 0;
        var k = parseInt(form['value-resolution-k-' + i]);
        var v = form['value-resolution-v-' + i];

        var resolution = [];

        while (k != undefined && v != undefined) {
            if (isNaN(k) == false) {
                resolution.push({
                    key: k,
                    value: v,
                });
            }

            i++;
            k = parseInt(form['value-resolution-k-' + i]);
            v = form['value-resolution-v-' + i];
        }

        return _.sortBy(resolution, 'key');
    },

    getValueResolutionFormat: function (form) {
        if (form.data_type_select != 'value_resolution') {
            return '';
        }

        var i = 0;
        var k = parseInt(form['value-resolution-k-' + i]);
        var v = form['value-resolution-v-' + i];

        var resolution = {};

        while (k != undefined && v != undefined) {
            if (isNaN(k) == false) {
                resolution[k] = v;
            }

            i++;
            k = parseInt(form['value-resolution-k-' + i]);
            v = form['value-resolution-v-' + i];
        }

        return Object.keys(resolution).length > 0 ? 'r' + JSON.stringify(resolution) : '';
    },

    getModelData: function (form) {
        return {
            spec: 0,
            name: form.name,
            type: form.type_select,
            nr: parseInt(form.nr),
            length: form.data_type_select == 'float' ? 2 : parseInt(form.length),
            min: parseInt(form.min || 0),
            max: parseInt(form.max || 65535),
            data_type: Misc.getValueLikeCoil(form.type_select)
                ? (form.cmapping_0 || i18n.TR('AUS')) + '-(0)/' + (form.cmapping_1 || i18n.TR('AN')) + '-(1)'
                : form.data_type_select,
            value_mapping: [parseFloat(form.vmapping_min || 0), parseFloat(form.vmapping_max || 0)],
            coil_mapping: [form.cmapping_0 || i18n.TR('AUS'), form.cmapping_1 || i18n.TR('AN')],
            value_resolution: this.getValueResolution(form),
            value_resolution_format: this.getValueResolutionFormat(form),
            is_readonly: form.is_readonly || form.type_select == 'MBI' || form.type_select == 'MBD',
            is_unit_fixed: form.unitFixed,
            is_signed: form.is_signed,
            is_little_endian: form.is_little_endian,
            is_decimal_combination: form.is_decimal_combination,
            display_unit: this.model && this.model.get('spec') != 0 ? (form.unitFixed ? form.unit : '') : form.unit,
            update_class: parseInt(form.update_class_select),
        };
    },

    validateForm: function (e) {
        e.preventDefault();
        var self = this;

        if (this.allFieldsValid()) {
            var form = Backbone.Syphon.serialize(this);

            var update = self.getModelData(form);
            if (Misc.getValueLikeRegister(form.type_select) && this.isSpecialFormat) {
                update.data_type = 'special_format';
            }
            update.value_mapping = self.toBaseMapping(update.value_mapping, update.min, update.max);

            if (this.model) {
                var model = this.model.toJSON();
                if (model.spec != 0 && model.type === update.type && model.nr === update.nr) {
                    // keep reference to value_specs-entry -> value is regarded as not-customized
                    update.spec = model.spec;
                }
            }

            Decorator.disableElement('.modal-dialog');
            this.options.update_value_cb({
                model: this.model,
                updated_model: update,
                success: function () {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen gespeichert.'));
                },
                error: function (errors) {
                    self.errors = errors;
                    self.reInitializeModel();
                    Decorator.enableElement('.modal-dialog');
                },
            });
        }
    },

    reInitializeModel: function (e) {
        var formData = this.getModelData(Backbone.Syphon.serialize(this));
        $.extend(this.formData, formData);

        this.testResult = undefined;

        this.render();
    },

    testConfiguration: function (e) {
        var deviceID = this.options.deviceID;
        var form = Backbone.Syphon.serialize(this);

        var dataPoints = [];
        var startAddr = parseInt(form.nr || 0);
        for (var i = 0; i < form.length; i++) {
            dataPoints.push(form.type_select + '_' + (startAddr + i));
        }

        var reqMap = {};
        reqMap[deviceID] = dataPoints;

        if (startAddr == 0 || form.length > 4) {
            return;
        }

        this.testResultIsFetched = true;
        this.reInitializeModel();

        var self = this;
        var req = App.request('devices:registers', reqMap, {});
        $.when(req).done(function (resp) {
            self.testResultIsFetched = false;

            if (resp.raw === undefined || resp.errors[deviceID] !== undefined) {
                self.testResult = i18n.TR('Werte konnten nicht geladen werden.');
                self.render();
                return;
            }

            var values = resp.raw[deviceID];
            var resultValue = 0;

            self.testResult = '';

            if (Misc.getValueLikeCoil(form.type_select)) {
                // special handling: coils
                for (var i = 0; i < form.length; i++) {
                    var v = values[form.type_select + '_' + (startAddr + i)];
                    self.testResult += v + ' ';
                }

                if (form.length == 1) {
                    // format coil value
                    self.testResult +=
                        ' = <strong>' +
                        (values[form.type_select + '_' + startAddr] == 0
                            ? form.cmapping_0 || i18n.TR('AUS')
                            : form.cmapping_1 || i18n.TR('AN')) +
                        '</strong>';
                }

                self.render();
                return;
            }

            // show raw data response
            for (var i = 0; i < form.length; i++) {
                var v = values[form.type_select + '_' + (startAddr + i)];
                self.testResult += v + ' ';

                var factor = form.is_decimal_combination
                    ? Math.pow(10, (form.length - i - 1) * 3)
                    : Math.pow(2, i * 16);
                resultValue += v * factor;
            }
            self.testResult += '= ';

            if (form.is_little_endian) {
                resultValue = 0;
                self.testResult += '(LE) ';
                for (var i = 0; i < form.length; i++) {
                    var v = values[form.type_select + '_' + (startAddr + i)];
                    v = ((v & 0xff) << 8) | ((v >> 8) & 0xff);

                    self.testResult += v + ' ';

                    var factor = form.is_decimal_combination
                        ? Math.pow(10, (form.length - i - 1) * 3)
                        : Math.pow(2, i * 16);
                    resultValue += v * factor;
                }
                self.testResult += '= ';
            }

            if (form.is_signed) {
                switch (form.length) {
                    case '1':
                        resultValue = resultValue > 0x7fff ? resultValue - 0x10000 : resultValue;
                        break;
                    case '2':
                        resultValue = resultValue > 0x7fffffff ? resultValue - 0x100000000 : resultValue;
                        break;
                    case '4':
                        resultValue =
                            resultValue > 0x7fffffffffffffff ? resultValue - 0x10000000000000000 : resultValue;
                        break;
                }
            }

            if (form.data_type_select == 'float') {
                var v1 = values[form.type_select + '_' + startAddr];
                var v2 = values[form.type_select + '_' + (startAddr + 1)];

                var buffer = new ArrayBuffer(4);
                var bytes = new Uint8Array(buffer);

                bytes[0] = (v1 & 0xff00) >> 8;
                bytes[1] = v1 & 0x00ff;
                bytes[2] = (v2 & 0xff00) >> 8;
                bytes[3] = v2 & 0x00ff;

                var view = new DataView(buffer);

                resultValue = Math.round(view.getFloat32(0, form.is_little_endian) * 1000);
            }

            var dt = _.find(self.supportedDataTypes, function (dt) {
                return dt.value == form.data_type_select;
            });
            var format = dt.format;

            if (form.data_type_select == 'value_mapping') {
                var mapping = self.toBaseMapping(
                    [parseFloat(form.vmapping_min || 0), parseFloat(form.vmapping_max || 0)],
                    form.min,
                    form.max
                );
                format = 'm[' + mapping[0] + ',' + mapping[1] + ']f2';
            }
            if (form.data_type_select == 'value_resolution') {
                format = self.getValueResolutionFormat(form);
            }

            var formatted = Misc.getValueDisplayInfos(
                resultValue,
                form.type_select,
                format,
                form.unit,
                form.unitFixed ? form.unit : '',
                form.unitFixed
            );

            self.testResult +=
                '<strong>' + (formatted.value || resultValue) + ' ' + (formatted.unit || form.unit) + '</strong>';

            self.render();
        });
    },

    onShow: function () {
        $('#js-modal-dialog .modal-dialog').addClass('modal-lg');
    },

    onDestroy: function () {
        $('#js-modal-dialog .modal-dialog').removeClass('modal-lg');
    },
});

module.exports = ConfigureValueDialogView;
